export async function requestUserPermissionsForCamAndMic() {
  return null;
}

export async function checkUserPermissionsForCamAndMic() {
  return null;
}
